import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

export const documentSigningSuccessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/document_signing_success',
  validateSearch: z.object({
    signedOutsideFaks: z.boolean(),
  }),
}).lazy(() =>
  import('pages/shared/DocumentSigningSuccessPage/DocumentSigningSuccessPage').then((d) => d.Route)
);
